import axios from 'axios'
import swal from 'sweetalert'

import { changeProjectPage, changeDeliverablesPage } from './manageProjectFilters'

import { handleErrorFetchingData } from '../../../functions/errorHandling'
import getServerURL from '../../../functions/getServerURL'


let defaultState = {
  fetchingProjects: false,
  fetchingDeliverables: false,
  fetchingMetadata: false,
  currentProject: null,
  nextPage: null,
  previousPage: null,
  projectCount: 0,
  projectResultsPerPage: 1,
  projectStatusCounts: {
    active: 0,
    completed: 0,
    notStarted: 0,
    onHold: 0,
  },
  projects: [],

  deliverables: [],
  deliverableCount: 0,
  deliverableResultsPerPage: 1,
  deliverableStatusCounts: {
    onGoing: 0,
    pastDue: 0,
    notStarted: 0,
    completed: 0,
  },

  metadata: [],
  clientProposals: [],
  thisIsANewVariableToTestTheReduxPersistFix: [],

  projectsCancelToken: null,
  deliverablesCancelToken: null,
}

export default function manageProjects(state = defaultState, action) {
  switch (action.type) {
    case "FETCHING_PROJECTS":
      return {...state, fetchingProjects: true}
    case "FETCHING_DELIVERABLES":
      return {...state, fetchingDeliverables: true}
    case "FETCHING_METADATA":
      return {...state, fetchingMetadata: true}
    case "ERROR_GETTING_PROJECTS":
      return {
        ...state,
        projects: [],
        nextPage: null,
        previousPage: null,
        projectCount: 0,
        projectResultsPerPage: 1,
        projectStatusCounts: {
          active: 0,
          completed: 0,
          notStarted: 0,
          onHold: 0,
        },
        refreshDisabled: false,
        fetchingProjects: false,
      }
    case "SET_PROJECTS":
      return {
        ...state,
        projects: action.payload.results,
        nextPage: action.payload.next,
        previousPage: action.payload.previous,
        projectCount: action.payload.count,
        projectResultsPerPage: action.payload.results_per_page,
        projectStatusCounts: {
          active: action.payload.active_count,
          completed: action.payload.completed_count,
          notStarted: action.payload.not_started_count,
          onHold: action.payload.on_hold_count,
        },
        refreshDisabled: false,
        fetchingProjects: false,
      }
    case "ERROR_GETTING_DELIVERABLES":
      return {
        ...state,
        fetchingDeliverables: false,
        deliverables: [],
        deliverableCount: 0,
        deliverableResultsPerPage: 1,
        deliverableStatusCounts: {
          onGoing: 0,
          pastDue: 0,
          notStarted: 0,
          completed: 0,
        },
      }
    case "SET_DELIVERABLES":
      return {
        ...state,
        fetchingDeliverables: false,
        deliverables: action.payload.results,
        deliverableCount: action.payload.total_count,
        deliverableResultsPerPage: action.payload.results_per_page,
        deliverableStatusCounts: {
          onGoing: action.payload.on_going_count,
          pastDue: action.payload.past_due_count,
          notStarted: action.payload.not_started_count,
          completed: action.payload.completed_count,
        },
      }
    case "DELETE_DELIVERABLE":
      if (state.currentProject) {
        const filteredProjectDeliverables = state.currentProject.deliverables.filter(deliverable => deliverable.id !== action.payload)

        const filteredDeliverables = state.deliverables.filter(deliverable => deliverable.id !== action.payload)

        return {...state, currentProject: {...state.currentProject, deliverables: filteredProjectDeliverables }, deliverables: filteredDeliverables }
      } else {
        return state
      }
    case "SET_METADATA":
      return { ...state, metadata: action.payload, fetchingMetadata: false }
    case "DELETE_PROJECT":
      const filteredProjects = [...state.projects].filter(proj => {
        return proj.id !== action.payload.id
      })
      return { ...state, projects: filteredProjects }
    case "ADD_METADATA":
      return {...state, metadata: [...state.metadata, action.payload]}
    case "EDIT_METADATA":
      const indexOfMetadata = state.metadata.findIndex(meta => meta.id === action.payload.id)

      return {...state, metadata: [...state.metadata.slice(0, indexOfMetadata), action.payload, ...state.metadata.slice(indexOfMetadata + 1)]}
    case "DELETE_METADATA":
        const filteredMetadata = state.metadata.filter(meta => meta.id !== action.payload)
        return {...state, metadata: filteredMetadata}
    case "ADD_METADATA_VALUE":
      const foundMetadataIndex = state.metadata.findIndex(meta => {
        return meta.url === action.payload.metadata
      })
      const updatedMetadata = {
        ...state.metadata[foundMetadataIndex],
        metadata_values: [
          ...state.metadata[foundMetadataIndex].metadata_values, action.payload
        ]
      }
      const updatedMetadataList = [
        ...state.metadata.slice(0, foundMetadataIndex),
        updatedMetadata,
        ...state.metadata.slice(foundMetadataIndex + 1),

      ]
      return { ...state, metadata: updatedMetadataList }
    case "EDIT_METADATA_VALUE":
      const metadataIndex = state.metadata.findIndex(meta => meta.url === action.payload.metadata)

      let updatedMeta = state.metadata[metadataIndex]

      const valueIndex = updatedMeta.metadata_values.findIndex(value => value.id === action.payload.id)

      updatedMeta = {...updatedMeta, metadata_values: [...updatedMeta.metadata_values.slice(0, valueIndex), action.payload, ...updatedMeta.metadata_values.slice(valueIndex + 1)]}

      return {
        ...state,
        metadata: [
          ...state.metadata.slice(0, metadataIndex),
          updatedMeta,
          ...state.metadata.slice(metadataIndex + 1),
        ]
      }
    case "DELETE_METADATA_VALUE":
      const metadataIndexToRemoveValueFrom = state.metadata.findIndex(meta => meta.url === action.payload.metadata)

      let metadataToRemoveValueFrom = state.metadata[metadataIndexToRemoveValueFrom]

      const filteredMetadataValues = metadataToRemoveValueFrom.metadata_values.filter(value => value.id !== action.payload.id)

      metadataToRemoveValueFrom = {
        ...metadataToRemoveValueFrom,
        metadata_values: filteredMetadataValues,
      }

      return {
        ...state,
        metadata: [
          ...state.metadata.slice(0, metadataIndexToRemoveValueFrom),
          metadataToRemoveValueFrom,
          ...state.metadata.slice(metadataIndexToRemoveValueFrom + 1),
        ]
      }
    case "SET_CLIENT_PROPOSALS":
      return { ...state, clientProposals: action.payload }
    case "CLEAR_CLIENT_PROPOSALS":
      return { ...state, clientProposals: [] }
    case "SET_PROJECTS_CANCEL_TOKEN":
      return { ...state, projectsCancelToken: action.payload }
    case "SET_DELIVERABLES_CANCEL_TOKEN":
      return { ...state, deliverablesCancelToken: action.payload }
    default:
      return state
  }
}

// functions to let reducer know data is being fetched

const fetchingProjects = () => {
  return { type: "FETCHING_PROJECTS"}
}

const fetchingDeliverables = () => {
  return { type: "FETCHING_DELIVERABLES"}
}

const fetchingMetadata = () => {
  return { type: "FETCHING_METADATA"}
}

// functions for setting data in reducer

const setProjects = (data) => {
  return { type: "SET_PROJECTS", payload: data }
}

const setDeliverables = (deliverables) => {
  return { type: "SET_DELIVERABLES", payload: deliverables }
}

const setMetadata = (data) => {
  return { type: "SET_METADATA", payload: data }
}

export const deleteDeliverable = (deliverable) => {
  return { type: "DELETE_DELIVERABLE", payload: deliverable }
}

export const projectDeleted = (project) => {
  return { type: "DELETE_PROJECT", payload: project }
}

export const addMetadata = (metadata) => {
  return { type: "ADD_METADATA", payload: metadata }
}

export const editMetadata = (metadata) => {
  return { type: "EDIT_METADATA", payload: metadata }
}

export const deleteMetadata = (metadataId) => {
  return { type: "DELETE_METADATA", payload: metadataId }
}

export const addMetadataValue = (metadataValue) => {
  return { type: "ADD_METADATA_VALUE", payload: metadataValue }
}

export const editMetadataValue = (metadataValue) => {
  return { type: "EDIT_METADATA_VALUE", payload: metadataValue }
}

export const deleteMetadataValue = (metadataValue) => {
  return { type: "DELETE_METADATA_VALUE", payload: metadataValue }
}

export const getProjects = (page = 1, filters = null, sort_by = null, my_projects = false, projectsCancelToken) => {
  return (dispatch) => {

    // Check if there is an axios cancel token for projects, and if so, cancel the previous request (this is used to handle a case of a user quickly clicking multiple projects filters)
    if (projectsCancelToken && typeof projectsCancelToken === 'object' && projectsCancelToken.cancel) {
      projectsCancelToken.cancel('Cancel projects get request')
    }

    // Set a new projectsCancelToken if one doesn't exist or the current one has been cancelled
    projectsCancelToken = axios.CancelToken.source()

    dispatch(setProjectsCancelToken(projectsCancelToken))
    dispatch(fetchingProjects())
    dispatch(changeProjectPage(page))

    axios({
      method: "GET",
      url: `${getServerURL()}projects/`,
      headers: { "Authorization": "Bearer " + localStorage.getItem("token")},
      cancelToken: projectsCancelToken.token,
      params: {
        page,
        list_view: true,
        filters,
        sort_by,
        my_projects,
      },
    })
    .then(response => {
      dispatch(setProjects(response.data))
    })
    .catch(error => {
      if (error && error.message && error.message === 'Cancel projects get request') {
        return
      } else {
        handleErrorFetchingData(error)
        dispatch(errorGettingProjects())
      }
    })
  }
}

const errorGettingProjects = () => {
  return { type: "ERROR_GETTING_PROJECTS" }
}

const errorGettingDeliverables = () => {
  return { type: "ERROR_GETTING_DELIVERABLES" }
}

export const createProjectFilters = (props) => {
  let filters, project_leads, analysts, status, regulatory_related, metadata_values, title, clients, sort_by, rduids

  if (props.projectLeadFilter.length) {
    project_leads = props.projectLeadFilter.map(project_lead => project_lead.id)
  }

  if (props.analystFilter.length) {
    analysts = props.analystFilter.map(analyst => analyst.id)
  }

  if (props.clientFilter.length) {
    clients = props.clientFilter.map(client => client.id)
  }

  if (props.metadataFilters.length) {
    metadata_values = props.metadataFilters.map(metadataValue => metadataValue.id)
  }

  if (props.statusFilter.length) {
    status = props.statusFilter
  }

  if (props.regulatoryRelatedFilter.length) {
    regulatory_related = props.regulatoryRelatedFilter
  }

  if (props.projectNameFilter) {
    title = props.projectNameFilter
  }

  if (props.projectRduidFilter && props.projectRduidFilter.length) {
    rduids = props.projectRduidFilter
  }


  if (project_leads || analysts || status || regulatory_related || title || metadata_values || clients || rduids) {
    filters = {
        project_leads,
        analysts,
        clients,
        status,
        regulatory_related,
        metadata_values,
        title,
        rduids,
      }
  }

  if (props.projectSortType) {
    sort_by = props.projectSortType
  }

  return { filters, sort_by }
}


export const createDeliverablesFilters = (props) => {
  let deliverables_filters, project_leads, analysts, project_status, deliverable_status, clients, deliverables_sort_by, assigned_to, search_term, metadata_values

  if (props.projectLeadFilter && props.projectLeadFilter.length) {
    project_leads = props.projectLeadFilter.map(project_lead => project_lead.id)
  }

  if (props.analystFilter && props.analystFilter.length) {
    analysts = props.analystFilter.map(analyst => analyst.id)
  }

  if (props.clientFilter && props.clientFilter.length) {
    clients = props.clientFilter.map(client => client.id)
  }

  if (props.metadataFilters && props.metadataFilters.length) {
    metadata_values = props.metadataFilters.map(metadataValue => metadataValue.id)
  }

  if (props.deliverableStatusFilter && props.deliverableStatusFilter.length) {
    deliverable_status = props.deliverableStatusFilter
  }

  if (props.deliverableAssignedToFilter && props.deliverableAssignedToFilter.length) {
    assigned_to = props.deliverableAssignedToFilter.map(user => user.id)
  }

  if (props.statusFilter && props.statusFilter.length) {
    project_status = props.statusFilter
  }

  if (props.deliverableSearchTerm) {
    search_term = props.deliverableSearchTerm
  }


  if (project_leads || analysts || project_status || deliverable_status || clients || deliverables_sort_by || assigned_to || search_term) {
    deliverables_filters = {
        project_leads,
        analysts,
        clients,
        metadata_values,
        project_status,
        deliverable_status,
        assigned_to,
        search_term,
      }
  }

  if (props.deliverableSortType) {
    deliverables_sort_by = props.deliverableSortType
  }

  return { deliverables_filters, deliverables_sort_by }
}


export const getProjectsWithFilters = (pageNumber, props) => {
  return (dispatch) => {
    const { filters, sort_by } = createProjectFilters(props)
    dispatch(getProjects(pageNumber, filters, sort_by, props.myProjectsFilter, props.projectsCancelToken))
  }
}

export const getProjectsAndDeliverablesWithFilters = (projectPageNumber, deliverablePageNumber, props, my_projects) => {
  return (dispatch) => {
    const { filters, sort_by } = createProjectFilters(props)
    const { deliverables_filters, deliverables_sort_by } = createDeliverablesFilters(props)
    dispatch(getProjects(projectPageNumber, filters, sort_by, props.myProjectsFilter, props.projectsCancelToken))
    dispatch(getDeliverables(deliverablePageNumber, deliverables_filters, deliverables_sort_by, props.myDeliverablesFilter, props.deliverablesCancelToken))
  }
}

export const getDeliverablesWithFilters = (pageNumber, props) => {
  return (dispatch) => {
    const { deliverables_filters, deliverables_sort_by } = createDeliverablesFilters(props)
    dispatch(getDeliverables(pageNumber, deliverables_filters, deliverables_sort_by, props.myDeliverablesFilter, props.deliverablesCancelToken))
  }
}

const setDeliverablesCancelToken = (deliverablesCancelToken) => {
  return { type: "SET_DELIVERABLES_CANCEL_TOKEN", payload: deliverablesCancelToken }
}

const setProjectsCancelToken = (projectsCancelToken) => {
  return { type: "SET_PROJECTS_CANCEL_TOKEN", payload: projectsCancelToken }
}

export const getDeliverables = (page = 1, filters = null, sort_by = null, my_deliverables = false, deliverablesCancelToken) => {
  return (dispatch) => {

    // Check if there is an axios cancel token for deliverables, and if so, cancel the previous request (this is used to handle a case of a user quickly clicking multiple deliverables filters)
    if (deliverablesCancelToken && typeof deliverablesCancelToken === 'object' && deliverablesCancelToken.cancel) {
      deliverablesCancelToken.cancel('Cancel deliverables get request')
    }

    // Set a new deliverablesCancelToken if one doesn't exist or the current one has been cancelled
    deliverablesCancelToken = axios.CancelToken.source()

    dispatch(setDeliverablesCancelToken(deliverablesCancelToken))
    dispatch(changeDeliverablesPage(page))
    dispatch(fetchingDeliverables())

    axios({
      method: "GET",
      url: `${getServerURL()}project-deliverables/`,
      headers: { "Authorization": "Bearer " + localStorage.getItem("token")},
      cancelToken: deliverablesCancelToken.token,
      params: {
        page,
        filters,
        sort_by,
        my_deliverables,
      },
    })
    .then(response => {
      dispatch(setDeliverables(response.data))
    })
    .catch(error => {
      if (error && error.message && error.message === 'Cancel deliverables get request') {
        return
      } else {
        handleErrorFetchingData(error)
        dispatch(errorGettingDeliverables())
      }
    })
  }
}

export const deleteProject = (project) => {
  swal({
    text: "Deleting the project... Please stand by.",
    icon: require("../../../static/images/spinner.gif"),
    button: false
  })
  return (dispatch) => {
    axios({
      method: "DELETE",
      url: project.url,
      headers: {"Authorization": "Bearer "+localStorage.getItem("token")}}
    )
    .then(response => {
      swal({
        title: "Success!",
        text: `Project ${project.short_id}-${project.number}-${project.title} has been deleted!`,
        icon: "success",
        button: "Continue!",
      })
      .then(() => {
        dispatch(projectDeleted(project))
        window.location = '/'
      })
    })
    .catch(error => {
      const message = "There was an error deleting your project"
      return handleErrorFetchingData(error, message)
    })
  }
}


export const getMetadata = () => {
  return function(dispatch){
    dispatch(fetchingMetadata())
    axios(`${getServerURL()}metadata/`,{
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("token")
      }
    })
    .then(response => {
      dispatch(setMetadata(response.data))
    })
    .catch(error => {
      handleErrorFetchingData(error)
    })
  }
}

const setClientProposals = (proposals) => {
  return { type: "SET_CLIENT_PROPOSALS", payload: proposals }
}

export const clearClientProposals = () => {
  return { type: "CLEAR_CLIENT_PROPOSALS" }
}


export const getClientProposals = (client) => {
  return function(dispatch) {
    axios(`${getServerURL()}client-proposals/`,{
        headers: {
          "Authorization": "Bearer " + localStorage.getItem("token")
        },
        params: {
          client,
        }
      })
      .then(response => {
        dispatch(setClientProposals(response.data))
      })
      .catch(error => {
        const message = "There was an error fetching this client's proposals. Please refresh to try again."
        handleErrorFetchingData(error, message)
      })
  }
}



// WEBPACK FOOTER //
// ./src/routes/projects/reducers/manageProjects.js